import { useEffect, useState } from "react";
import { Spin } from "antd";
import { selector } from "../../api";
import { char, code, number } from "../../utils";
import { LoadingOutlined } from "@ant-design/icons";
import { appCRUD } from "../../actions/app";
import { DataDay, DataType } from "./data";

export const HomeContent = () => {
  const user = selector.User();
  const [count, setCount] = useState({});
  const [countLoading, setCountLoading] = useState(false);

  useEffect(() => {
    setCountLoading(true)
    setTimeout(() => {
      appCRUD.loadDashboardTotal().then((resp) => {
        setCount(resp.data)
      })
      .catch(() => {})
      .finally(() => {
        setCountLoading(false)
      })
    },500)
  },[])

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="mb-3 pb-1">
            <div className="col-12">
              <div className="d-flex align-items-lg-center flex-lg-row flex-column">
                <div className="flex-grow-1">
                  <h4 className="fs-16 mb-1">
                    Welcome,{" "}
                    {char.toTitleCase(code.getFirstWord(user.first_name))}...!
                  </h4>
                  <p className="text-muted mb-0">
                    Here's what's happening in our university.
                  </p>
                </div>
              </div>
              {/* end card header */}
            </div>
            {/*end col*/}
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-xl-3">
            <div className="card card-animate">
              {countLoading ? (
                <div className="text-center mt-4 mb-4">
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{
                          fontSize: 24,
                        }}
                        spin
                      />
                    }
                  />
                </div>
              ) : (
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        {" "}
                        total printed id
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between mt-4">
                    <div className="text-dark">
                      <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                        <span className="counter-value">
                          {count
                            ? number.fShortenNumber(count.customer)
                            : "0.0"}
                        </span>
                      </h4>
                    </div>
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-soft-success rounded fs-3">
                        <i className="bx bx-user text-success" />
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-3">
            <div className="card card-animate">
              {countLoading ? (
                <div className="text-center mt-4 mb-4">
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{
                          fontSize: 24,
                        }}
                        spin
                      />
                    }
                  />
                </div>
              ) : (
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        {" "}
                        total lost id
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between mt-4">
                    <div className="text-dark">
                      <h4 className="fs-22 fw-semibold ff-primary mb-4">
                        <span className="counter-value">
                          {count ? number.fShortenNumber(count.trip) : "0.0"}
                        </span>
                      </h4>
                    </div>
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-soft-primary rounded fs-3">
                        <i className="ri-ship-line text-primary" />
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-3">
            <div className="card card-animate">
              {countLoading ? (
                <div className="text-center mt-4 mb-4">
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{
                          fontSize: 24,
                        }}
                        spin
                      />
                    }
                  />
                </div>
              ) : (
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        {" "}
                        total active id
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between mt-4">
                    <div className="text-dark">
                      <h4 className="fs-22 fw-semibold ff-info mb-4">
                        <span className="counter-value">
                          {count
                            ? number.fShortenNumber(count.container)
                            : "0.0"}
                        </span>
                      </h4>
                    </div>
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-soft-info rounded fs-3">
                        <i className="ri-luggage-cart-line text-info" />
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-3">
            <div className="card card-animate">
              {countLoading ? (
                <div className="text-center mt-4 mb-4">
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{
                          fontSize: 24,
                        }}
                        spin
                      />
                    }
                  />
                </div>
              ) : (
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    <div className="flex-grow-1 overflow-hidden">
                      <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
                        {" "}
                        total expiry id
                      </p>
                    </div>
                  </div>
                  <div className="d-flex align-items-end justify-content-between mt-4">
                    <div className="text-dark">
                      <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                        <span className="counter-value">
                          {count
                            ? number.fNumberDoublePoint(count.rate)
                            : "0.0"}
                        </span>
                      </h4>
                    </div>
                    <div className="avatar-sm flex-shrink-0">
                      <span className="avatar-title bg-soft-secondary rounded fs-3">
                        <i className="ri-exchange-dollar-line text-secondary" />
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* <div className="row">
          <div className="col-xl-8 col-md-8">
            <div className="card card-animate">
              <div className="card-body text-start">
                <DataDay />
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-md-4">
            <div className="card card-animate">
              <div className="card-body text-start">
                <DataType />
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
};
